import React, { useContext, useEffect, useState } from "react";
import '../style/table.css';
import { AuthContext } from "../context/AuthContext";
import AutoMultiSearch from "../components/CustomizedHook/AutoMultiSearch";
import DropdownComponent from "../components/dropdown/DropdownComponent";
import DropdownPropertys from "../components/dropdown/DropdownPropertys";
import DropdownMulti from "../components/dropdown/DropdownMulti";
import MoreFilters from "../components/dropdown/MoreFilters";
import { numRegex } from "../Const";
import { StoreContext } from "../context/StoreContext";
import { useNavigate } from "react-router";
import { rentFqcyARY } from "../components/CommonFun";

const transactionsHistoryData = [
  {
    date: "26 Dec 2025",
    location: "Al Barsha South 5, Al Barsha",
    price: "956,368",
    psprice: "1594",
    type: "Apartment",
    beds: "1 Bed",
    contractStatus:"Off-plan",
    area: "599.98 sqft",
    floor: "16",
  },
  {
    date: "26 Dec 2025",
    location: "Al Barsha South 5, Al Barsha",
    price: "1,115,840",
    psprice: "1549.32",
    type: "Apartment",
    beds: "Studio",
    contractStatus:"Off-plan",
    area: "720.21 sqft",
    floor: "30",
  },
  {
    date: "25 Dec 2025",
     location: "Al Barsha South 5, Al Barsha",
    price: "515,000",
    psprice: "1345.48",
    type: "Villa",
    beds: "2 Beds",
    contractStatus:"Ready",
    area: "7340.12 sqft",
    floor: "-",
  },
];

export default function TransactionsHistory() {
    const navigate = useNavigate();
    const { completionType,fetchCompletionType, purposeType, fetchPurposeType, categoriesType, fetchCategoriesType, cityData, fatchCity } = useContext(AuthContext);
    const { localityData, fatchLocality } = useContext(StoreContext);
    const [serLoader, setSerLoader] = useState(false);
    const [combinedData, setCombinedData] = useState([]);
    const [filters, setFilters] = useState(null);
    const [bannerFilter, setBannerFilter] = useState({
        purpose: "sale",
        categorySlug: "Residential",
        categoryName: [],
        categories: [],
        bedRooms: [],
        baths: [],
        minPrice: "",
        maxPrice: "",
        location: "",
        completion: "all",
        minArea: "",
        maxArea: "",
        locality: "",
        rent_frequency: "",
        city: "",
    });
    useEffect(() => {
        fetchCategoriesType();
        fetchPurposeType();
        fatchLocality();
        fatchCity();
        fetchCompletionType()
    }, []);

    useEffect(() => {
        const updatedCityData = cityData.map((city) => ({ name: city.cityName, Keyname: "city" }));
        const updatedLocalityData = localityData.map((locality) => ({ name: locality.name, Keyname: "locality" }));
        const combined = [...updatedCityData, ...updatedLocalityData];
        setCombinedData(combined);
    }, [localityData, cityData]);
    const filterCallBack = (option, name) => {
        let newFilterData = { ...bannerFilter };
        newFilterData[name] = option;
        if (name === "minPrice" || name === "maxPrice" || name === "minArea" || name === "maxArea") {
            if (option != 0) {
                if (/^0/.test(option)) option = option.replace(/^0+/, "");
                if (numRegex.test(option)) setBannerFilter({ ...bannerFilter, [name]: option });
            } else setBannerFilter({ ...bannerFilter, [name]: "" });
        } else if (name === "completion") setBannerFilter({ ...bannerFilter, [name]: option });
        else setBannerFilter(option);
    };
    const handlesearch = () => {
        setSerLoader(true);
        // navigate(findPRtdata)
        // fechLtsProperties(1, bannerFilter);
    };
    const handleReset = () => {
        setSerLoader(true);
        navigate("/property/for-sale");
        let data = {
            purpose: "sale",
            categorySlug: "Residential",
            categoryName: [],
            categories: [],
            bedRooms: [],
            baths: [],
            minPrice: "",
            maxPrice: "",
            location: "",
            completion: "all",
            maxArea: "",
            minArea: "",
            rent_frequency: "",
            city: "",
        };
        setBannerFilter(data);
        setFilters(data);
    };
   const filterReset = () => {
    };
    return (
        <div>
            <div className="property-dropdown">
                <div className="container">
                    <div className="hero-dropdown-sec filter_fropdown">
                        {purposeType?.length > 0 && <DropdownComponent name="Buy" kName="purpose" option={purposeType} bannerFilter={bannerFilter} filterCallBack={filterCallBack} />}
                        <AutoMultiSearch
                            data={combinedData}
                            filterData={bannerFilter}
                            filterCallBack={filterCallBack}
                            kName="name"
                            plshdr="Enter location"
                            multiShow={false}
                            handleReset={handleReset}
                            isIcon={true}
                            filterReset={filterReset}
                        />
                        {bannerFilter?.purpose.toLowerCase() === "sale" ? (
                            <div className="buy-tab-btn property-buy-tab">
                                <div className="tab-buttons">
                                    <button className={`tab-btn${bannerFilter.completion === "all" ? " active" : ""}`} onClick={() => filterCallBack("all", "completion")}>
                                        All
                                    </button>
                                    {completionType &&
                                        completionType.length > 0 &&
                                        completionType.map((item, i) => (
                                            <button key={i} className={`tab-btn${bannerFilter.completion === item?.type ? " active" : ""}`} onClick={() => filterCallBack(item.type, "completion")}>
                                                {item?.name}
                                            </button>
                                        ))}
                                </div>
                            </div>
                        ) : (
                            <DropdownComponent name="yearly" kName="rent_frequency" option={rentFqcyARY} bannerFilter={bannerFilter} filterCallBack={filterCallBack} />
                        )}
                        {categoriesType?.length > 0 && (
                            <div className="dropdown">
                                <DropdownPropertys categoriesType={categoriesType} bannerFilter={bannerFilter} filterCallBack={filterCallBack} />
                            </div>
                        )}
                        {bannerFilter?.categorySlug === "Residential" && <DropdownMulti name="Beds & Baths" bannerFilter={bannerFilter} filterCallBack={filterCallBack} />}
                        <MoreFilters plchdlr="Price (AED)" filterData={bannerFilter} filterCallBack={filterCallBack} minKey="minPrice" maxKey="maxPrice" />
                    </div>
                    <div className="dropdown-footer">
                        <button className="button reset_btn me-2" onClick={handleReset} disabled={serLoader}>
                            Reset
                        </button>
                        <button className="button search_btn" onClick={handlesearch} disabled={serLoader}>
                            Search
                            {serLoader && <span className="spinner-border spinner-border-sm ms-2" aria-hidden="true"></span>}
                        </button>
                    </div>
                </div>
            </div>
            <div className="hist_table">
                 <div className="container">
                <div className="">
                    <h2>Sale History</h2>
                </div>
                <div className="table-wrapper">
                    <table className="property-table">
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Location</th>
                                <th>Price (AED)</th>
                                <th>Price (Per sqft)</th>
                                <th>Type</th>
                                <th>Beds</th>
                                <th>Contract Status</th>
                                <th>Area</th>
                                <th>Floor</th>
                            </tr>
                        </thead>
                        <tbody>
                            {transactionsHistoryData.map((item, index) => (
                                <tr key={index}>
                                    <td data-label="Date">{item.date}</td>
                                    <td data-label="Location">{item.location}</td>
                                    <td data-label="Price (AED)" className="price">
                                        {item.price}
                                    </td>
                                    <td data-label="Price (Per sqft)" className="price">
                                        {item.psprice}
                                    </td>
                                    <td data-label="Type">{item.type}</td>
                                    <td data-label="Beds">{item.beds}</td>
                                    <td data-label="Contract Status" className={item.contractStatus == "Ready" ?"text-success" :"text-danger"}>{item.contractStatus}</td>
                                    <td data-label="Area">{item.area}</td>
                                    <td data-label="Floor">{item.floor}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                </div>
            </div>
        </div>
    );
}
